// extracted by mini-css-extract-plugin
export default {"container":"LearningCourseSelection__container___cwoG_"};